import { DatabaseChangeType } from '@databases/types/redux';

import { YJSChangeHandler } from '../../types';

export const setFieldDescription: YJSChangeHandler<
  DatabaseChangeType.SET_FIELD_DESCRIPTION
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    if (field) {
      field.applyDescriptionDelta(change.delta);
    }
  });
};
